"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pages = void 0;
// eslint-disable-next-line no-shadow
var Pages;
(function (Pages) {
    //----------------------------------------------------------------
    // SHARED
    //----------------------------------------------------------------
    // -----------
    // PUBLIC
    // -----------
    Pages["ROOT"] = "/";
    Pages["PUBLIC_DETAILS_REPORT"] = "/public/detailsreport/:key";
    Pages["PUBLIC_LMSS_REPORT"] = "/public/lmssreport/:key";
    Pages["PUBLIC_DASHBOARD_REPORT"] = "/public/dashboardreport/:key";
    // --------
    // AUTH
    // --------
    Pages["AUTH_RESET"] = "/reset";
    Pages["AUTH_FORCE_RESET"] = "/forcereset";
    Pages["AUTH_FORGOT"] = "/forgot";
    Pages["AUTH_SIGNIN"] = "/signin";
    Pages["AUTH_SIGNOUT"] = "/signin";
    Pages["AUTH_SIGNIN_ENTEROTP"] = "/signin/enterotp";
    Pages["AUTH_SIGNIN_TEAMBOARD"] = "/signin/teamboard";
    Pages["AUTH_SIGNIN_PHONE"] = "/signin/phone";
    Pages["AUTH_SWITCH"] = "/switch";
    //---------
    // REPORTS
    //---------
    Pages["REPORT_EDIT"] = "*/report/edit/:viewId";
    Pages["REPORT_DELETE"] = "*/report/delete/:viewId";
    Pages["REPORT_COLUMNS"] = "*/report/columns/:viewId";
    Pages["REPORT_CREATE"] = "*/report/saveas/:viewId";
    Pages["REPORT_EXPORT"] = "*/report/export/:viewId/:type";
    Pages["DASHBOARD_EXPORT"] = "*/dashboard/export";
    // --------
    // WILDCARDS
    // --------
    Pages["GRAPHQL"] = "/graphql";
    Pages["PROFILE"] = "*/profile";
    Pages["ONBOARDING"] = "/operations/onboarding";
    Pages["IMPORT_DATA"] = "*/importdata/:type";
    //----------------------------------------------------------------
    // WEB APP
    //----------------------------------------------------------------
    // -----------
    // TO DO
    // -----------
    Pages["TODO"] = "/todo";
    Pages["TODO_OPS"] = "/todo/ops";
    Pages["OPS_CREATE"] = "/todo/ops/op/ondemand/perform";
    Pages["TODO_ISSUES"] = "/todo/issues";
    Pages["ISSUE_CREATE"] = "/todo/issues/create";
    //----------
    // OPERATIONS - PROCEDURES
    //----------
    Pages["OP_DEFINITIONS"] = "/operations/procedures/:viewId";
    Pages["OP_DEFINITIONS_CREATE"] = "/operations/procedures/create";
    Pages["OP_DEFINITIONS_ASSIGN"] = "*/procedure/assign";
    Pages["OP_DEFINITIONS_EDIT"] = "*/procedure/:id/edit";
    Pages["OP_DEFINITIONS_MULTI_EDIT"] = "*/procedure/:id/multiedit";
    Pages["OP_DEFINITIONS_COPY"] = "*/procedure/:id/copy";
    Pages["OP_DEFINITIONS_DELETE"] = "*/procedure/:id/delete";
    Pages["OP_DEFINITIONS_PUBLISH"] = "*/procedure/:id/publish";
    Pages["OP_DEFINITIONS_REVERT"] = "*/procedure/:id/revert";
    Pages["OP_DEFINITIONS_ENABLE"] = "*/procedure/:id/enable";
    Pages["OP_DEFINITIONS_DISABLE"] = "*/procedure/:id/disable";
    Pages["OP_SCHEDULE_DELETE"] = "*/schedule/:id/delete";
    Pages["OP_SCHEDULE_EDIT"] = "*/schedule/:id/edit";
    Pages["OP_SCHEDULE_CREATE"] = "*/:id/schedules/create";
    //---------------
    // CONVERSATIONS
    //---------------
    Pages["CONVERSATION_DETAILS"] = "*/conversations/details/:id";
    Pages["CONVERSATION_DETAILS_NEW"] = "*/conversations/details/new/:title";
    // -----------
    // OPERATIONS - BUSINESS RULES
    // -----------
    Pages["WORKFLOWS"] = "/operations/rules";
    Pages["WORKFLOWS_EDIT"] = "*/rule/:id/edit";
    Pages["WORKFLOWS_PICKTRIGGER"] = "*/rule/picktrigger";
    Pages["WORKFLOWS_CREATE"] = "*/rule/create";
    Pages["WORKFLOWS_DELETE"] = "*/rule/:id/delete";
    Pages["WORKFLOWS_ENABLE"] = "*/rule/:id/enable";
    Pages["WORKFLOWS_DISABLE"] = "*/rule/:id/disable";
    // --------
    // ANALYTICS
    // --------
    Pages["DASHBOARD"] = "/analytics/dashboard";
    Pages["OPS_LOG"] = "/analytics/ops/:viewId";
    Pages["OPS_LOG_DIALOG"] = "*/ops/:viewId/analyse";
    Pages["ISSUES_LOG"] = "/analytics/issues/:viewId";
    Pages["ISSUES_LOG_DIALOG"] = "*/issues/:viewId/analyse";
    Pages["OPS_BYORG_LOG"] = "/analytics/ops/byorg";
    Pages["OPS_BYSTATUS_LOG"] = "/analytics/ops/bystatus";
    // -----------
    // SETUP -> PLACES
    // -----------
    Pages["PLACES"] = "/setup/places";
    // -----------
    // SETUP -> ASSETS
    // -----------
    Pages["ASSETS"] = "/setup/assets";
    Pages["ASSETS_CREATE"] = "/setup/assets/create";
    Pages["ASSETS_COMPARE"] = "/setup/assets/compare";
    // -----------
    // SETUP - USERS
    // -----------
    Pages["STAFF"] = "/setup/users/staff";
    Pages["STAFF_CREATE"] = "/setup/users/staff/create";
    Pages["TEAMBOARDS_CREATE"] = "/setup/users/teamboards/create";
    Pages["TEAMBOARDS"] = "/setup/users/teamboards";
    // --------
    // SETUP - ADVANCED
    // --------
    // OP SETTINGS
    Pages["QUESTION_SETS"] = "/setup/advanced/opsettings/questions";
    Pages["QUESTION_SETS_CREATE"] = "/setup/advanced/opsettings/questions/create";
    Pages["QUESTION_SETS_EDIT"] = "/setup/advanced/opsettings/questions/edit/:id";
    Pages["QUESTION_SETS_DELETE"] = "/setup/advanced/opsettings/questions/delete/:id";
    Pages["QUESTION_SETS_PUBLISH"] = "/setup/advanced/opsettings/questions/publish/:id";
    Pages["OPGRADESETTINGS"] = "/setup/advanced/opsettings/opgrades";
    Pages["OPTYPESETTINGS"] = "/setup/advanced/opsettings/optypes";
    Pages["OPREPORTSETTINGS"] = "/setup/advanced/opsettings/opreporting";
    // ISSUE SETTINGS
    Pages["ISSUETYPESETTINGS"] = "/setup/advanced/issuesettings/issuetypes";
    Pages["ISSUEFLAGSETTINGS"] = "/setup/advanced/issuesettings/issueflags";
    Pages["ISSUEREPORTSETTINGS"] = "/setup/advanced/issuesettings/issuereports";
    // ASSET SETTINGS
    Pages["ASSETTYPESETTINGS"] = "/setup/advanced/assetsettings/assettypes";
    Pages["ASSETCUSTOMFIELDS"] = "/setup/advanced/assetsettings/customfields";
    // REPORT SETTINGS
    Pages["REPORTSETTINGS"] = "/setup/advanced/reportsettings/settings";
    // USER SETTINGS
    Pages["POSITIONS"] = "/setup/advanced/usersettings/positions";
    Pages["TEAMS"] = "/setup/advanced/usersettings/teams";
    // INTEGRATIONS
    Pages["INTEGRATIONS_API"] = "/setup/advanced/integrations/api";
    Pages["INTEGRATIONS_IOT"] = "/setup/advanced/integrations/iot";
    Pages["INTEGRATIONS_IQM"] = "/setup/advanced/integrations/iqm";
    // --------
    // DIALOGS
    // --------
    // OP
    Pages["OP_VIEW"] = "*/op/:id/view";
    Pages["OP_PERFORM"] = "*/op/:id/perform";
    Pages["OP_CANCEL"] = "*/op/:id/cancel";
    Pages["OP_APPROVE"] = "*/op/:id/approve";
    Pages["OP_PREVIEW"] = "/op/:id/preview";
    Pages["OP_VIEW_ISSUES"] = "*/op/:id/issues";
    Pages["OP_DELETE"] = "*/op/:id/delete";
    Pages["OP_GENERATE_DETAILS_REPORT"] = "*/op/:id/generatereport";
    Pages["OP_TYPE_DELETE"] = "*/optype/:type/delete";
    // ISSUES
    Pages["ISSUES_VIEW"] = "*/issue/:id/view";
    Pages["ISSUES_CREATE"] = "*/issue/create";
    Pages["ISSUES_CLOSE"] = "*/issue/:id/close";
    Pages["ISSUES_REOPEN"] = "*/issue/:id/reopen";
    Pages["ISSUES_REASSIGN"] = "*/issue/:id/reassign";
    Pages["ISSUE_GENERATE_DETAILS_REPORT"] = "*/issue/:id/generatereport";
    Pages["ISSUE_TYPE_DELETE"] = "*/issuetype/:type/delete";
    Pages["ISSUES_MULTI_EDIT"] = "*/issue/:id/multiedit";
    // ASSETS
    Pages["ASSETS_EDIT"] = "*/asset/:id/edit";
    Pages["ASSETS_MULTI_EDIT"] = "*/asset/:id/multiedit";
    Pages["ASSETS_DELETE"] = "*/asset/:id/delete";
    Pages["ASSET_TYPE_DELETE"] = "*/assettype/:type/delete";
    // USERS
    Pages["STAFF_EDIT"] = "*/staff/:id/edit";
    Pages["STAFF_MULTI_EDIT"] = "*/staff/:id/multiedit";
    Pages["STAFF_DELETE"] = "*/staff/:id/delete";
    Pages["STAFF_INVITE"] = "*/staff/:id/invite";
    Pages["STAFF_ENABLE"] = "*/staff/:id/enable";
    Pages["STAFF_DISABLE"] = "*/staff/:id/disable";
    Pages["STAFF_CHANGEEMAIL"] = "*/staff/:id/changeemail";
    Pages["TEAMBOARDS_EDIT"] = "*/teamboards/:id/edit";
    Pages["TEAMBOARDS_MULTI_EDIT"] = "*/teamboards/:id/multiedit";
    Pages["TEAMBOARDS_DELETE"] = "*/teamboards/:id/delete";
    // TEAMS
    Pages["TEAMS_CREATE"] = "*/teams/create";
    Pages["TEAMS_DELETE"] = "*/teams/:id/delete";
    Pages["TEAMS_EDIT"] = "*/teams/:id/edit";
    // POSITIONS
    Pages["POSITIONS_CREATE"] = "*/positions/create";
    Pages["POSITIONS_EDIT"] = "*/positions/edit/:id";
    Pages["POSITIONS_DELETE"] = "*/positions/delete/:id";
    //----------------------------------------------------------------
    // ADMIN BASE
    //----------------------------------------------------------------
    // --------
    // ORGANISATIONS
    // --------
    Pages["ORGANISATIONS"] = "/organisations";
    Pages["ORGANISATIONS_EDIT"] = "/organisations/edit/:id";
    Pages["ORGANISATIONS_PURGE"] = "/organisations/purge/:id";
    Pages["ORGANISATIONS_DELETE"] = "/organisations/delete/:id";
    Pages["ORGANISATIONS_CREATE"] = "/organisations/create";
    Pages["PRIMARYADMIN_INVITE"] = "/organisations/edit/:id/primaryadmin/invite";
    Pages["PRIMARYADMIN_DELETE"] = "/organisations/edit/:id/primaryadmin/delete/:staffid";
    // --------
    // SUPERUSERS
    // --------
    Pages["SUPERUSERS"] = "/superusers";
    Pages["SUPERUSERS_DELETE"] = "/superusers/delete/:id";
    Pages["SUPERUSERS_EDIT"] = "/superusers/edit/:id";
    Pages["SUPERUSERS_CHANGEEMAIL"] = "*/superuser/:id/changeemail";
    Pages["SUPERUSERS_CREATE"] = "/superusers/create";
    // --------
    // SYSTEM SETTINGS
    // --------
    Pages["SYSTEMSETTINGS"] = "/settings/system";
    Pages["INDUSTRIES"] = "/settings/industries";
    Pages["INDUSTRY_EDIT"] = "/settings/industries/edit/:id";
    Pages["INDUSTRY_DELETE"] = "/settings/industries/delete/:id";
    Pages["INDUSTRY_CREATE"] = "/settings/industries/create";
    // --------
    // TASKS
    // --------
    Pages["TASKS"] = "/tasks";
    Pages["TASKS_CREATE"] = "/tasks/create";
    Pages["TASKS_EDIT"] = "/tasks/edit/:id";
    // --------
    // ICONS
    // --------
    Pages["ICONS"] = "/icons";
    // --------
    // TEMPLATES
    // --------
    Pages["TEMPLATES"] = "/template/templates";
    Pages["TEMPLATE_EDIT"] = "/template/templates/edit/:id";
    Pages["TEMPLATE_COPY"] = "/template/templates/copy/:id";
    Pages["TEMPLATE_DELETE"] = "/template/templates/delete/:id";
    Pages["TEMPLATE_CREATE"] = "/template/templates/create";
    Pages["TEMPLATE_SCHEDULE_DELETE"] = "*/schedule/delete/:id";
    // --------
    // ORG TEMPLATES
    // --------
    Pages["ORG_TEMPLATES"] = "/setup/advanced/opsettings/templates";
    Pages["ORG_TEMPLATE_EDIT"] = "/setup/advanced/opsettings/templates/edit/:id";
    Pages["ORG_TEMPLATE_COPY"] = "/setup/advanced/opsettings/templates/copy/:id";
    Pages["ORG_TEMPLATE_ROLLOUT"] = "/setup/advanced/opsettings/templates/rollout/:id";
    Pages["ORG_TEMPLATE_DELETE"] = "/setup/advanced/opsettings/templates/delete/:id";
    Pages["ORG_TEMPLATE_CREATE"] = "/setup/advanced/opsettings/templates/create";
    Pages["ORG_TEMPLATE_SCHEDULE_DELETE"] = "*/schedule/delete/:id";
})(Pages = exports.Pages || (exports.Pages = {}));
exports.default = Pages;
